import React, { useEffect } from "react";
import WebFont from "webfontloader";

const googleFonts = [
    "Abril Fatface",
    "Bitter",
    "Birthstone",
    "Comfortaa",
    "Corinthia",
    "DM Serif Text",
    "Fredoka",
    "Geist",
    "Gloock",
    "Great Vibes",
    "Italianno",
    "Luxurious Script",
    "Oleo Script Swash Caps",
    "Pacifico",
    "Pattaya",
    "Pinyon Script",
    "Style Script",
    "Yanone Kaffeesatz",
];

export default function GoogleFontSelector({ value, onChange }) {
  // Load selected font when changed
  useEffect(() => {
    WebFont.load({
      google: {
        families: googleFonts,
      },
    });
  }, []);

  return (
    <select value={value} onChange={(e) => onChange(e.target.value)}>
      {googleFonts.map((font) => (
        <option key={font} value={font} style={{ fontFamily: font }}>
          {font}
        </option>
      ))}
    </select>
  );
}
